import { isEmpty } from "lodash";
import {
  INIT_APP3,
  INIT_APP3_SUCCESS,
  INIT_APP3_CONNECTED,
  INIT_APP3_READY_CLIENT,
  INIT_APP3_READY_SERVER,
  LOAD_CONFIGURATION3,
  LOAD_CONFIGURATION3_SUCCESS,
  LOAD_PUBLIC_CONFIGURATION3,
  ERROR,
  WARNING,
  LOAD_HTMLTEMPLATES3_SUCCESS,
  CONFIRM_WARNING,
  RESUME_TICKET,
  CLEAR_RESUME_TICKET,
  SET_PAGE_TITLE,
  APP3_OFFLINE,
  SET_MODAL_CONTENT,
  SOCKET_DISCONNECT,
} from "../constants";

/**
 * Dispatch INIT_APP3 to reducer, letting it know that we are init the app
 *
 * NOTE: As initApp-flag in reducer is by default set to false. This might be a unnecessary action.
 * For now we keep it, but we might consider removing it in a future version.
 */
// eslint-disable-next-line
export function initApp3({}) {
  return {
    type: INIT_APP3,
  };
}

/**
 * Dispatch INIT_APP3_CONNECTED to reducer, letting it know that we are init the app
 *
 * NOTE: As initApp-flag in reducer is by default set to false. This might be a unnecessary action.
 * For now we keep it, but we might consider removing it in a future version.
 */
// eslint-disable-next-line
export function initApp3Connection({}) {
  return {
    type: INIT_APP3_CONNECTED,
  };
}

export function initApp3ReadyServer() {
  return {
    type: INIT_APP3_READY_SERVER,
  };
}

export function initApp3ReadyClient() {
  return {
    type: INIT_APP3_READY_CLIENT,
  };
}

/**
 * Let reducer know that we have an established socker connect and we are successfully init
 */
// eslint-disable-next-line
export const initApp3Success = ({}) => {
  return {
    type: INIT_APP3_SUCCESS,
  };
};

/**
 * Signal that we are offline
 */
export const app3Offline = ({ isOffline }) => {
  return {
    type: APP3_OFFLINE,
    isOffline,
  };
};

export const socketDisconnect = () => {
  return {
    type: SOCKET_DISCONNECT,
  };
};

/**
 * Let reducer know that we have an established socker connect and we are successfully init
 */
// eslint-disable-next-line
export const loadConfiguration3 = ({}) => {
  return {
    type: LOAD_CONFIGURATION3,
  };
};

/**
 * Let reducer know that we have an established socker connect and we are successfully init
 */
export const loadConfiguration3Success = (configuration) => {
  return {
    type: LOAD_CONFIGURATION3_SUCCESS,
    configuration,
  };
};

// eslint-disable-next-line
export const loadPublicConfiguration3 = ({}) => {
  return {
    type: LOAD_PUBLIC_CONFIGURATION3,
  };
};

/**
 * Send global error to reducer for display
 */
export const error = (error) => {
  return {
    type: ERROR,
    error,
  };
};

/**
 * Send global warning to reducer for display
 */
export const warning = (warning) => {
  return {
    type: WARNING,
    warning,
  };
};

/**
 * Send global warning to reducer for display
 */
export const confirmWarning = () => {
  return {
    type: CONFIRM_WARNING,
  };
};

export function loadHTMLTemplate3Success(templates) {
  return {
    type: LOAD_HTMLTEMPLATES3_SUCCESS,
    templates,
  };
}

export const resumeTicket = ({
  currentFormDataId,
  formDataId,
  removeActiveTicket,
}) => {
  return {
    type: RESUME_TICKET,
    currentFormDataId,
    formDataId,
    removeActiveTicket,
  };
};

export const clearResumeTicket = () => {
  return {
    type: CLEAR_RESUME_TICKET,
  };
};

export const setPageTitle = ({ pageTitle }) => {
  return {
    type: SET_PAGE_TITLE,
    pageTitle,
  };
};

export const setAppModalContent = (props) => {
  return {
    type: SET_MODAL_CONTENT,
    modalContent: props && !isEmpty(props) ? { ...props } : null,
  };
};
